export default "__VITE_ASSET__DtvjGoO3__"